import styled from "styled-components";

// ** for wide scope
export const AddWorkingCondition = styled.div`
    display: flex;
    background-color: rgba(0, 119, 204, 0.2);
    color: #0061a6;
    border-radius: 6px;
    width: 40px;
    height: 40px;
    font-size: 40px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

// *** for Sales only move it to sales
export const MileageUnitEditable = styled.div`
    position: absolute;
    top: 70%;
    right: 75%;
    font-size: 15px;
    font-weight: bold;
`;

// *** for Supplier only move it to Supplier
export const ConfirmSpo = styled.div`
    flex: 1;
    display: flex;
    padding: 4rem;
`;
// *** for OldSupplier & OldSales only move it to theme or delet it and replace with Hint
export const ErrorHint = styled.div`
    flex: 1;
    display: flex;
    padding: 0rem 4rem;
`;
// *** for OldSupplier & OldSales only move it to theme
export const DefaultHintMsg = styled.div`
    flex: 1;
    display: flex;
    padding: 0rem 0 2rem 0rem;
    color: #e98010;
    align-items: center;
    font-size: 18px;
    svg {
        margin: 0 0.5rem;
    }
`;

// *** for SupplyChain only move it
export const ButtonContainer = styled.div`
    flex: 1;
    display: flex;
    justify-content: flex-end;
    margin: 2rem;
    button {
        margin: 0 1rem;
    }
`;
// ? Keep it here
export const TrashIconStyle = styled.div`
    color: #ff0000;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
`;
// *** for OldSupplier & Supplier only move it to theme
export const StylesButtonLink = styled.div`
    color: #0061a6;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
    margin: 12px 0;
    text-decoration: underline;

    &&.disable {
        color: gray;
    }
`;
// *** for OldSupplier & Supplier only move it to theme
export const HintMsg = styled.div`
    color: #f0ad00;
    font-size: 16px;
    font-weight: 700;
    display: flex;
    align-items: center;
    line-height: 2;
    margin-top: 1rem;
    svg {
        margin: 0.5rem;
    }
`;
// *** for OldSupplier & Supplier only move it to theme
export const HintSuccessMsg = styled.div`
    color: #21a600;
    font-size: 16px;
    font-weight: 700;
    display: flex;
    align-items: center;
    line-height: 2;
    margin-top: 1rem;
    svg {
        margin: 0.5rem;
    }
`;
// *** for OldSupplier & Supplier only move it to theme
export const TextEditorContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
// *** for deactivateModale & declineModal only move it to theme
export const ParagraphStyle = styled.div`
    font-size: 1.4rem;
    color: black;
    margin-top: 2rem;
`;
// ? keep it
export const CheckBoxContainer = styled.div`
    padding: 20px;
    border: 1px solid #e4e6f0;
    border-radius: 17px;
`;
